
import { TAO_KOE } from 'libs/index.js';

window.PictofitPromise = window.PictofitPromise || new Promise( ( resolve ) => {
	window.onPictofitReady = ( builder ) => {
		resolve( builder );
	};
} );

class PictofitHandler {
	getOrganizationId() {
		return '2f1025f9-4a5f-46da-84c5-a46717600489';
	}

	#hasLoaded = false;
	async loadScript() {
		// RR already loaded.
		if ( this.#hasLoaded ) {
			return window.PictofitPromise;
		}

		// Create Script.
		const scriptEl = document.createElement( 'script' );
		scriptEl.async = true;
		scriptEl.type = 'module';
		scriptEl.src = 'https://cdn.pictofit.com/pictofit-web-components/kuo/kuo/kuo-entry-point.mjs';

		// Append Script to Head.
		document.head.appendChild( scriptEl );

		// Return Promise so we know, that loading finished.
		this.#hasLoaded = true;
		return window.PictofitPromise;
	}

	#buildPromise = null;
	async build() {
		this.#buildPromise = this.#buildPromise || this.loadScript().then( async( builder ) => {
			// PICTOFiT was loaded
			// Define the organization ID
			const org = this.getOrganizationId();

			// create a virtual styling builder
			const virtualStylingBuilder = builder
				.forOrganisation( org )
				.asVirtualStyling();

			// Create a custom commerce provider for KuO
			const commerceProvider = window.rr.kuo_commerce( async( id, size ) => {
				// Callback for adding to cart
				// id == ArticleNR
				// size == IdentNr
				console.log( `Add to cart`, id, size ); // eslint-disable-line no-console
				return await window.AclMiniBasket.addArticleBySku( size ).then( () => {

				} ).catch( ( response ) => {
					return Promise.reject( response.error[ 0 ].message );
				} );
			} );

			// Create a custom information provider for KuO
			const informationProvider = window.rr.kuo_information();

			// This initializes the generic sharing provider and handle shared links
			window.rr.kuo_initialize( virtualStylingBuilder, commerceProvider, informationProvider );

			// Build the virtual styling compoment API
			return virtualStylingBuilder.build().then( async( ft ) => {
				// Return build for further use later.
				return {
					rr: window.rr,
					ft,
					virtualStylingBuilder,
					commerceProvider,
					informationProvider,
				};
			} );
		} );

		return this.#buildPromise;
	}

	// Collection reference to load, is associated with organization ID
	// gid://pictofit/collection/glanzvolle zeiten - herren
	// gid://pictofit/collection/glanzvolle zeiten
	// gid://pictofit/collection/test_collection
	// this can also be preloaded and validated if the collection should be offered for opening
	// const col = "gid://pictofit/collection/glanzvolle zeiten - herren";
	// Setting open variable to a function to open the experience
	open( col ) {
		return this.build().then( async( { ft, virtualStylingBuilder, commerceProvider, informationProvider } ) => {
			// Virtual styling component available
			const api = ft.api;

			// Load the collection via the reference
			const collection = await virtualStylingBuilder.getCollection( col );

			if ( collection === null ) {
				// The collection was not found ...
				throw new Error( `Collection not found ...` );
			}

			// Preload data for this collection from the feed
			await window.rr.kuo_preload_collection( collection );

			// Test how many outfits and garments would be available in the experience
			// based on stock availability
			// This can be used to make a decision if the virtual styling experience should be
			// shown, for example if there are too little outfits left
			const { garments, outfits } = await informationProvider.checkAvailableAssets( Promise.resolve( collection ) );

			console.log( `Garments ${ garments }, Outfits ${ outfits }` ); // eslint-disable-line no-console

			// Open the actual Fairytale experience
			api.show( Promise.resolve( collection ), {
				reference: col,
				organizationId: this.getOrganizationId(),
			}, {
				commerceProvider,
				informationProvider,
			} );
		} );
	}
}

const Handler = new PictofitHandler();

const initPictofitLinks = ( scopeEl = document ) => {
	const linksEls = scopeEl.querySelectorAll( 'a[href^="gid://"]' );
	if ( linksEls.length > 0 ) {
		// Preload and prepare Reactive Realities Modal.
		Handler.build();
	}

	scopeEl.addEventListener( 'click', ( ev ) => {
		const linkEl = ev.target.closest( 'a[href^="gid://"]' );
		if ( linkEl ) {
			ev.preventDefault();
			Handler.open( decodeURI( linkEl.href ) );
		}
	} );
};

TAO_KOE.ready( 'pictofit', () => initPictofitLinks() );

export {
	Handler as default,
	initPictofitLinks,
};
